import noop from 'lodash/noop';
import deepcopy from 'ts-deepcopy';
import { CustomPanelCreationResponseOutcomeEnum } from '@invitae/stargate-ts-fetch';

// empty context
var defaultContext = {
    addPartnerships: noop,
    addReflexTests: noop,
    addRereqTests: noop,
    addToCart: noop,
    cart: undefined,
    clearCart: noop,
    clearCartErrors: noop,
    clearReflexCustomizedSelection: noop,
    clearRereqCustomizedSelection: noop,
    closeOpenedMiniCart: noop,
    configureExomeAddOn: noop,
    customModalProps: {},
    getCart: noop,
    gotoCartPage: noop,
    goToSignInPage: noop,
    hasInvalidExomeAddOnConfiguration: false,
    partnershipToAdd: '',
    reflexValidationErrors: {},
    removeAllPartnerships: function () { return Promise.resolve({}); },
    removeFromCart: noop,
    removePartnerships: noop,
    removeReflexTests: noop,
    removeRereqTests: noop,
    requestPending: false,
    rereqValidationError: false,
    saveCustomPanel: function () { return Promise.resolve({ outcome: CustomPanelCreationResponseOutcomeEnum.Success }); },
    searchPartnerships: function () { return Promise.resolve([]); },
    searchReflexTests: function () { return Promise.resolve([]); },
    searchRereqTests: function () { return Promise.resolve([]); },
    setHasInvalidExomeAddOnConfiguration: noop,
    setPartnershipToAdd: noop,
    setReflexOptions: noop,
    setReflexValidationErrors: noop,
    setRereqValidationError: noop,
    setShouldKeepMiniCartOpen: noop,
    shouldKeepMiniCartOpen: false,
    shouldShowPartnershipWarning: false,
    showLoadingOverlay: noop,
    showPatientInfoBanner: true,
    toggleCustomModalForm: noop,
    user: undefined,
};
var copyDefaultContext = function () { return deepcopy(defaultContext); };
var PARTNERSHIP_CODE_REMOVED_MESSAGE = "The partner code was removed as it's no longer valid.";
var PARTNERSHIP_CODE_NOT_ADDED_MESSAGE = "The partner code was not added as it's not valid.";

export { PARTNERSHIP_CODE_NOT_ADDED_MESSAGE, PARTNERSHIP_CODE_REMOVED_MESSAGE, copyDefaultContext };
//# sourceMappingURL=CartContext.utils.esm.js.map
